export default __webpack_public_path__ + "static/media/Group 8-5.f4cb64e8.svg";